import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";

function PaymentDetailsSection({
  serviceFee = "",
  onServiceFeeChange,
  paymentStatusOptions = [],
  paymentMethodOptions = [],
  onPaymentStatusChange,
  onPaymentMethodChange,
  readOnly = false,
  titleServiceFee = "Service Fee",
  titlePaymentStatus = "Payment Status",
}) {
  return (
    <>
      <Grid item xs={12}>
        <Card variant="outlined" sx={{ mb: 2 }}>
          <CardHeader
            title={
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", textTransform: "uppercase" }}
              >
                {titleServiceFee}
              </Typography>
            }
            sx={{ pb: 0, px: 2, pt: 2 }}
          />
          <CardContent sx={{ px: 2, pb: 2 }}>
            <TextField
              label="Service Fee"
              value={serviceFee || ""}
              onChange={(e) => onServiceFeeChange?.(e.target.value)}
              fullWidth
              size="small"
              disabled={readOnly}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">₱</InputAdornment>
                ),
                readOnly: readOnly,
              }}
            />
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <Card variant="outlined" sx={{ mb: 2 }}>
          <CardHeader
            title={
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", textTransform: "uppercase" }}
              >
                {titlePaymentStatus}
              </Typography>
            }
            sx={{ pb: 0, px: 2, pt: 2 }}
          />
          <CardContent sx={{ px: 2, pb: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 700, mb: 1, textTransform: "uppercase" }}
                >
                  Status
                </Typography>

                <FormGroup>
                  {paymentStatusOptions.map((option, index) => (
                    <FormControlLabel
                      key={option.label || index}
                      control={
                        <Checkbox
                          checked={!!option.selection}
                          onChange={() => onPaymentStatusChange?.(index)}
                          disabled={readOnly}
                        />
                      }
                      label={option.label || ""}
                    />
                  ))}
                </FormGroup>
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 700, mb: 1, textTransform: "uppercase" }}
                >
                  Method
                </Typography>

                <FormGroup>
                  {paymentMethodOptions.map((option, index) => (
                    <FormControlLabel
                      key={option.label || index}
                      control={
                        <Checkbox
                          checked={!!option.selection}
                          onChange={() => onPaymentMethodChange?.(index)}
                          disabled={readOnly}
                        />
                      }
                      label={option.label || ""}
                    />
                  ))}
                </FormGroup>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </>
  );
}

export default PaymentDetailsSection;